export const genderEmpty = 'everything';
export const genderItems = [genderEmpty, 'women', 'men'];
export const genderLabels = ["Filter", "Women", "Men"];



// WEBPACK FOOTER //
// ./src/utils/gender.js